import { MapPin, ExternalLink } from 'lucide-react';

export function PropertyLocationCard({ property, t }) {
  if (!property.lat && !property.latitude && !property.google_maps_link) return null;

  const mapsUrl = property.google_maps_link || `https://www.google.com/maps?q=${property.lat || property.latitude},${property.lng || property.longitude}`;

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm" data-testid="property-location-card">
      <h3 className="text-lg font-semibold text-[#1C1917] mb-4" style={{ fontFamily: 'Outfit' }}>
        {t('detail.location')}
      </h3>
      <div className="space-y-3 mb-4">
        {property.address && (
          <p className="text-sm text-[#57534E]"><MapPin className="w-4 h-4 inline mr-1 text-[#264639]" />{property.address}</p>
        )}
        <div className="flex flex-wrap gap-2 text-sm text-[#57534E]">
          {property.neighborhood && <span className="bg-[#F5F4F0] px-2 py-1 rounded">{property.neighborhood}</span>}
          {property.city && <span className="bg-[#F5F4F0] px-2 py-1 rounded">{property.city}</span>}
          {property.state && <span className="bg-[#F5F4F0] px-2 py-1 rounded">{property.state}</span>}
          {property.country && (
            <span className="bg-[#F5F4F0] px-2 py-1 rounded">
              {property.country === 'Argentina' ? '\u{1F1E6}\u{1F1F7}' : property.country === 'Brasil' ? '\u{1F1E7}\u{1F1F7}' : '\u{1F1F5}\u{1F1FE}'} {property.country}
            </span>
          )}
        </div>
      </div>
      <div className="rounded-lg overflow-hidden h-48 bg-[#EAE8E3] flex items-center justify-center">
        <a href={mapsUrl} target="_blank" rel="noopener noreferrer"
          className="flex items-center text-[#264639] hover:underline font-medium" data-testid="google-maps-link">
          <MapPin className="w-5 h-5 mr-2" /> {t('detail.viewMaps')} <ExternalLink className="w-4 h-4 ml-1" />
        </a>
      </div>
    </div>
  );
}
